import React from "react";
import classNames from "classnames/bind";
import Rating from "react-rating";

// assets
import { StarIcon } from "src/assets/icons";

import styles from "./Rating.module.scss";
const cx = classNames.bind(styles);

const RatingComponent = ({ rate = 0, classname, size = "base" }) => {
  return (
    <div className={cx("rating-root", size, classname)}>
      <Rating
        initialRating={parseFloat(rate).toFixed(1)}
        emptySymbol={<StarIcon fillcolor="#e6e6e6" />}
        fullSymbol={<StarIcon fillcolor="#FFC107" />}
        readonly
      />
    </div>
  );
};

export default RatingComponent;
